module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('transition', {
    attrs: {
      "name": "dawn-modal"
    },
    on: {
      "afterEnter": _vm.onshow
    }
  }, [(_vm.show) ? _c('div', {
    staticClass: "dawn-modal-mask",
    on: {
      "click": _vm.close
    }
  }, [_c('div', {
    staticClass: "dawn-modal-container",
    on: {
      "click": function($event) {
        $event.stopPropagation();
      }
    }
  }, [_c('div', {
    staticClass: "dawn-modal-top"
  }, [_c('span', {
    staticClass: "close-icon",
    on: {
      "click": _vm.close
    }
  }, [_c('i', {
    staticClass: "fal fa-times"
  })])]), _c('div', {
    staticClass: "dawn-modal-header"
  }, [_c('h3', {
    staticClass: "title"
  }, [_vm._v(_vm._s(_vm.title))]), _c('p', {
    staticClass: "subtitle"
  }, [_vm._v(_vm._s(_vm.subtitle))])]), _vm._t("body"), _c('div', {
    staticClass: "dawn-modal-footer text-right"
  }, [_vm._t("footer"), (!_vm.hasSlotFooter) ? _c('div', [(_vm.secondaryButton != 'false') ? _c('ed-button', {
    staticClass: "btn btn-secondary",
    on: {
      "click": _vm.close
    }
  }, [_vm._v(_vm._s(_vm.secondaryButton))]) : _vm._e(), (_vm.primaryButton != 'false') ? _c('ed-button', {
    staticClass: "btn btn-primary",
    on: {
      "click": _vm.close
    }
  }, [_vm._v(_vm._s(_vm.primaryButton))]) : _vm._e()], 1) : _vm._e()], 2)], 2)]) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-f268d324","hasScoped":true}!./~/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/core/components/edModal/index.vue
// module id = zhHn
// module chunks = 13 14